import React from 'react'
import '../styles/portfolio.css';

//  style={{ backgroundImage: `url('images/img-bg-small.jpg')`, backgroundSize: 'cover', padding: '10px' }}
const PortfolioCard = ({ title, location, description, imageUrl, onClick, selectImage }) => {

    // const mainImage = props.images?.find((image) => image.metadata?.isMain);


    return (

        <div className='portfolio-card-outer brass-gradient'
            onClick={onClick}
        >
            <div className='portfolio-card'>
                <div className='pc-1'>
                    <div className='show-img-pop'>
                        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129.53 129.53">

                            <rect className="pop-icon-stroke" x="2.49" y="2.49" width="124.55" height="124.55" rx="2.38" />
                            <path className="pop-icon-fill" d="M300.05,227.41l-10-.21-11-.21a.65.65,0,0,1-.63-.63l-.22-11-.2-10a.64.64,0,0,1,1.1-.47l5.83,5.83,73.23-73.23-5.83-5.83a.64.64,0,0,1,.47-1.1l10,.2,11,.22a.65.65,0,0,1,.63.63l.21,11,.21,10a.64.64,0,0,1-1.1.47l-5.84-5.83-73.22,73.22,5.83,5.84A.64.64,0,0,1,300.05,227.41Z" transform="translate(-261.66 -114.22)" />
                            <path className="pop-icon-fill" d="M374.85,205.36l-.21,10-.21,11a.65.65,0,0,1-.63.63l-11,.21-10,.21a.64.64,0,0,1-.47-1.1l5.83-5.84L329.79,192.1l9.75-9.75,28.37,28.37,5.84-5.83A.64.64,0,0,1,374.85,205.36Z" transform="translate(-261.66 -114.22)" />
                            <path className="pop-icon-fill" d="M278,152.61l.2-10,.22-11a.64.64,0,0,1,.63-.63l11-.22,10-.2a.64.64,0,0,1,.47,1.1l-5.83,5.83,28.36,28.37-9.75,9.75-28.37-28.36-5.83,5.83A.64.64,0,0,1,278,152.61Z" transform="translate(-261.66 -114.22)" />
                        </svg>
                    </div>
                    <div>


                        <img onClick={() => selectImage && selectImage(imageUrl)} src={`${imageUrl}`} alt={title} />



                    </div>
                </div>
                <div className='pc-2'>

                    <h2 className='project-title'>{title}</h2>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.71 110" className="location-icon-portfolio">

                            <path className="location-fill"
                                d="M252.15,328c-30.6,0-49.45,33.39-33.65,59.56l28.68,47.64a5.8,5.8,0,0,0,5,2.8,5.87,5.87,0,0,0,5-2.8l28.67-47.64a38.91,38.91,0,0,0,5.71-20.21C291.5,346.89,275.12,328,252.15,328Zm0,62.88a22,22,0,1,1,21.94-21.94A22,22,0,0,1,252.15,390.88Z"
                                transform="translate(-212.79 -328)" />
                        </svg>
                        <h4 className='location'>{location}</h4>

                    </div>

                    <div className='pc-line'></div>


                    <p className='description-project'>{description}</p>





                </div>
            </div>
        </div>
    )
}

export default PortfolioCard